import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-572dcbe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "profile-view"
}
const _hoisted_2 = { class: "profile-view__info" }
const _hoisted_3 = { class: "profile-view__photo" }
const _hoisted_4 = { class: "medium" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Город: ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Компания: ", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "medium" }, "Логотип:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bold" }, "Объявления пользователя:", -1))
const _hoisted_11 = { class: "mt--20" }
const _hoisted_12 = {
  key: 0,
  class: "profile-view__offerCards"
}
const _hoisted_13 = {
  key: 1,
  class: "profile-view__offerCards"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 0,
  class: "mt--10"
}

import { computed, onMounted, Ref, ref } from 'vue';
import { ResultCardType } from '@/types';
import { LoadingOfferCard, OfferSmallCard } from '@/components/Cards';
import { UserType, useUserStore } from '@/store/modules/user';
import { goToCard } from '@/utils/Cards/OfferCard';

type PaginationDataType = {
  page: number;
  pageSize: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const profileCards: Ref<ResultCardType[]> = ref([]);
const prepareValues = computed((): ResultCardType[] => {
  return profileCards.value;
});
const isLoadingProfileCards = ref(false);
const userInfo = computed((): UserType | undefined => {
  return useUserStore().user;
});
const userType = computed((): number | undefined => {
  return useUserStore().user?.type;
});
const paginationData: Ref<PaginationDataType> = ref({
  page: 1,
  pageSize: 6,
});
const objectCount: Ref<number | undefined> = ref(undefined);

const getMyHouses = async () => {
  try {
    isLoadingProfileCards.value = true;
    const res = await useUserStore().getMyHouses(paginationData.value);

    if (res) {
      profileCards.value = res.found;
      objectCount.value = res.count;
    }
  } finally {
    isLoadingProfileCards.value = false;
  }
};

const changePageAndPageSize = async (data: { page: number; pageSize: number }) => {
  if (
    data.pageSize !== paginationData.value.pageSize ||
    data.page !== paginationData.value.page
  ) {
    paginationData.value = {
      page: data.page,
      pageSize: data.pageSize,
    };
  }
  await getMyHouses();
};

onMounted(async () => {
  await getMyHouses();
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!

  return (userInfo.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_image, {
              contain: !userInfo.value.logo,
              cover: !!userInfo.value.logo,
              height: userInfo.value.logo ? '80' : '50',
              src: userInfo.value.logo || require('@/assets/img/profile/avatar.png'),
              width: userInfo.value.logo ? '80' : '50',
              name: "ava"
            }, null, 8, ["contain", "cover", "height", "src", "width"])
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(userInfo.value.name || 'Имя пользователя'), 1),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(userInfo.value.region), 1)
          ]),
          (userType.value !== 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(userInfo.value.profile.titleCompany || '-'), 1)
              ]))
            : _createCommentVNode("", true),
          (userType.value !== 1 && userInfo.value.profile.logoCompany)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_base_image, {
                  src: userInfo.value.profile.logoCompany,
                  class: "profile__content-avatar",
                  contain: "",
                  height: "80",
                  name: "ava",
                  width: "150"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (isLoadingProfileCards.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                    return _createElementVNode("div", { key: i }, [
                      _createVNode(_unref(LoadingOfferCard))
                    ])
                  }), 64))
                ]))
              : (profileCards.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileCards.value, (card) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: card.id
                      }, [
                        _createVNode(_unref(OfferSmallCard), {
                          card: card,
                          onMiddle: ($event: any) => (_unref(goToCard)(card.landUrl)),
                          onChangeActive: ($event: any) => (_unref(goToCard)(card.landUrl))
                        }, null, 8, ["card", "onMiddle", "onChangeActive"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, "Объявлений нет"))
          ]),
          (profileCards.value.length > 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_base_pagination_group, {
                  customPage: paginationData.value.page,
                  itemCountOnPage: paginationData.value.pageSize,
                  "max-for-visible": 24,
                  "min-for-visible": 6,
                  objectCount: objectCount.value,
                  "show-btn": false,
                  "step-for-visible": 6,
                  value: prepareValues.value,
                  values: profileCards.value,
                  "auto-add-mobile": "",
                  class: "mt--20",
                  onChangePageAndPageSize: changePageAndPageSize
                }, null, 8, ["customPage", "itemCountOnPage", "objectCount", "value", "values"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})